module.exports = __webpack_public_path__ + "img/button_casino_on.d2063eae.png";